import  {  useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import CreateSubject from "./CreateSubject";
import UpdateSubject from "./UpdateSubject";
import {
  useGetSubjectsQuery,
  useRemoveSubjectMutation,
} from "../../../features/api/subjectApi";

const Subjects = () => {
  const { data, isLoading } = useGetSubjectsQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const categories = data?.supplier;

  const [removeSubject] = useRemoveSubjectMutation();

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure your want to delete?");
    if (confirm) {
      try {
        const result = await removeSubject(id);
        if (result) {
          toast.success("Delete Success..!!!");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="px-12">
      <div className="flex justify-between items-center py-6">
        <h1 className="text-xl font-bold">Subject</h1>
        <CreateSubject />
      </div>
      <div className="">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : categories?.length === 0 ? (
          <p className=" text-xl text-red-500">There are no subject</p>
        ) : (
          <TableContainer
            component={Paper}
            // style={{ backgroundColor: "#f0f0f5" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    Sl No.
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    Title
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {categories
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => (
                    <TableRow key={row.id}>
                      <TableCell>{i + 1}</TableCell>
                      <TableCell>{row?.title}</TableCell>
                      <TableCell className="">
                        <div className="flex items-center gap-x-4">
                          <UpdateSubject category={row} />
                          <span onClick={() => handleDelete(row?.id)}>
                            <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                          </span>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            <TablePagination
              style={{ backgroundColor: "#f0f0f5" }}
              rowsPerPageOptions={[20, 30, 40]}
              component="div"
              count={categories?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default Subjects;
